import { render, staticRenderFns } from "./FilterSliderInput.vue?vue&type=template&id=640e8463&scoped=true&"
import script from "./FilterSliderInput.vue?vue&type=script&lang=js&"
export * from "./FilterSliderInput.vue?vue&type=script&lang=js&"
import style0 from "./FilterSliderInput.vue?vue&type=style&index=0&id=640e8463&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e8463",
  null
  
)

export default component.exports